import { NICmsContentComponent } from '@icms/core/content';

export namespace NTwoDimensionalCarousel {
    export const ID = 'two-dimensional-carousel';

    export interface IComponentData extends NICmsContentComponent.IData {
        sections: ISection[];
        autoplay?: boolean;
        delay?: number;
        creative?: boolean;
        navigationBottom?: boolean;
        pageTop?: boolean;
    }

    export interface ISection {
        bulletsTitles?: boolean;
        color: string;
        creative?: boolean;
        hide: boolean;
        items: {
            bgColor: string;
            color: string;
            components: NICmsContentComponent.IData[];
            creative?: boolean;
            hide: boolean;
            name: string;
        }[];
        name: string;
    }
}
